import { HttpClient, HttpErrorResponse, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { API } from '@constants';
import { API_BASE_URL } from '@constants/injection_tokens';
import { removeNullValues } from '@utils/utils';
import { tap, Observable, throwError, EMPTY } from 'rxjs';
import { UserTokenDetails } from 'src/app/auth/models';
import { AuthService } from 'src/app/auth/services/auth.service';
import {
  CompanyDetailsDTO,
  CompanyOffice,
  CompanyPhysicalOffice,
  CompanyWorker,
} from '../models/company';
import { toContactDTO } from '../models/contact';

@Injectable({
  providedIn: 'root',
})
export class CompanyService {
  private user: UserTokenDetails | undefined;
  private currentCompanyId: number | undefined;

  constructor(
    private auth: AuthService,
    private http: HttpClient,
    @Inject(API_BASE_URL) private baseUrl: string
  ) {
    this.auth.user.subscribe((data) => {
      if (data) {
        this.user = data;
      }
    });
  }

  public getCompany(bulstat: string = '') {
    const url = `${this.baseUrl}${API.COMPANY.GET}?bulstat=${bulstat || this.user?.bulstat}`;
    if (!this.user?.bulstat) return EMPTY;
    console.log(url);
    return this.http
      .get(url)
      .pipe(tap((company: any) => (this.currentCompanyId = company.id)));
  }

  public getCityMap<T>(cityId: number): Observable<T>{
    const url = `${this.baseUrl}${API.COMPANY.GETCITYMAP}?cityId=${cityId}`;
    return this.http
      .get<T>(url)
      .pipe();
  }

  public updateContact(contact: CompanyWorker, companyId: number) {
    return this.http.post(`${this.baseUrl}${API.COMPANY.UPDATE_CONTACT}`, {
      workers: [toContactDTO(contact, companyId)],
    });
  }

  public markWorkerAsPrimary(
    currentContact: CompanyWorker,
    previousWorker: CompanyWorker,
    companyId: number
  ) {
    return this.http.post(`${this.baseUrl}${API.COMPANY.UPDATE_CONTACT}`, {
      workers: [
        toContactDTO({ ...currentContact, primary: true }, companyId),
        previousWorker
          ? toContactDTO({ ...previousWorker, primary: false }, companyId)
          : undefined,
      ],
    });
  }

  public addContact(contact: any, companyId: number) {
    return this.http.post(`${this.baseUrl}${API.COMPANY.NEW_WORKER}`, {
      workers: [toContactDTO(contact, companyId)],
    });
  }

  public removeContact(contactId: number) {
    return this.http.delete(
      `${this.baseUrl}${API.COMPANY.DELETE_CONTACT}?workerId=${contactId}`
    );
  }

  public updateCompany(data: CompanyDetailsDTO) {
    const url = `${this.baseUrl}${API.COMPANY.UPDATE}`;
    return this.http.post(url, data);
  }

  public addOffice(office: CompanyOffice) {
    var item = new CompanyPhysicalOffice(office);

    const url = `${this.baseUrl}${API.COMPANY.ADD_OFFICE}`;
    return this.http.post(url, item);
  }

  public removeOffice(officeId: number) {
    const url = `${this.baseUrl}${API.COMPANY.DELETE_OFFICE}?companyId=${officeId}`;
    return this.http.delete(url);
  }

  public editOffice(office: Partial<CompanyOffice>) {
    var item = new CompanyPhysicalOffice(office);
    const url = `${this.baseUrl}${API.COMPANY.EDIT_OFFICE}`;
    return this.http.post(url, item);
  }

  public getWorkers() {
    const url = `${this.baseUrl}${API.COMPANY.GET_WORKERS}`;
    this.http.post(url, {}).subscribe((data) => console.log('workers', data));
  }
}
